import { render, staticRenderFns } from "./SideContent.vue?vue&type=template&id=4e0daa37&scoped=true&"
import script from "./SideContent.vue?vue&type=script&lang=js&"
export * from "./SideContent.vue?vue&type=script&lang=js&"
import style0 from "./SideContent.vue?vue&type=style&index=0&id=4e0daa37&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e0daa37",
  null
  
)

export default component.exports